// extracted by mini-css-extract-plugin
export default {"tableWrapper":"table_tableWrapper__k-Vyd","table":"table_table__hiyWB","offset":"table_offset__pwISt","tableScroll":"table_tableScroll__7ujuw"};